import { Component } from '@angular/core';

@Component({
  selector: 'app-section-dropdown',
  templateUrl: './section-dropdown.component.html',
  styleUrls: ['./section-dropdown.component.scss']
})
export class SectionDropdownComponent {
  public opened: boolean = true;

  public onToggle(): void {
    this.opened = !this.opened;
  }
}
